// Author Liang Gang Qiang
// Date 2022-10-14 11:38:14

class EmAdmUserTag {
    constructor({
                    id = null,
                    userLoginName = '',
                    tagKey = '',
                    tagValue = '',
                    userCode = '',
                    remark = ''}
                    = {}) {
        this.id = id;
        this.userLoginName = userLoginName;
        this.tagKey = tagKey;
        this.tagValue = tagValue;
        this.userCode = userCode;
        this.remark = remark;
    }
}

function newEntity() {
    return new EmAdmUserTag();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.admin.emAdmUserTag.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'userLoginName',
            label: 'label.em.admin.emAdmUserTag.grid.userLoginName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'userName',
            label: 'label.em.admin.emAdmUserTag.grid.userName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tagKey',
            label: 'label.em.admin.emAdmUserTag.grid.tagKey',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                    { value: 'Purchase_Group', text: '采购组' }
                ]
            }
        },
        {
            key: 'tagValue',
            label: 'label.em.admin.emAdmUserTag.grid.tagValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'userCode',
            label: 'label.em.admin.emAdmUserTag.grid.userCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.admin.emAdmUserTag.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    userLoginNameFilter : '',
    userNameFilter : '',
    tagKeyFilter : '',
    tagValueFilter : '',
    userCodeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'userLoginNameFilter',
        label: 'label.em.admin.emAdmUserTag.filter.userLoginName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'userNameFilter',
        label: 'label.em.admin.emAdmUserTag.filter.userName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tagKeyFilter',
        label: 'label.em.admin.emAdmUserTag.filter.tagKey',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
            ,options: [
                { value: 'Purchase_Group', text: '采购组' }
            ]
        }
    },
    {
        key: 'tagValueFilter',
        label: 'label.em.admin.emAdmUserTag.filter.tagValue',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'userCodeFilter',
        label: 'label.em.admin.emAdmUserTag.filter.userCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'userLoginName',
        label: 'label.em.admin.emAdmUserTag.entity.userLoginName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
        }
    },
    {
        key: 'tagKey',
        label: 'label.em.admin.emAdmUserTag.entity.tagKey',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
            ,options: [
                { value: 'Purchase_Group', text: '采购组' }
            ]
        }
    },
    {
        key: 'tagValue',
        label: 'label.em.admin.emAdmUserTag.entity.tagValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'userCode',
        label: 'label.em.admin.emAdmUserTag.entity.userCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.admin.emAdmUserTag.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {EmAdmUserTag, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
